"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubscriptionCardLicenseInfo = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const bridge_schema_1 = require("@completeanatomy/bridge-schema");
const device_1 = require("@completeanatomy/device");
const i18n_1 = require("@completeanatomy/i18n");
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const Subtitle_1 = require("../../atoms/Subtitle/Subtitle");
const Title_1 = require("../../atoms/Title/Title");
function SubscriptionCardLicenseInfo({ isMobile, license, }) {
    var _a;
    const { t } = (0, i18n_1.useTranslation)();
    const isGerman = (0, device_1.useStateLanguage)() === 'de';
    const isStudentLicense = (license === null || license === void 0 ? void 0 : license.type) === bridge_schema_1.LicenseType.StudentPlus;
    const hasOffer = (_a = license === null || license === void 0 ? void 0 : license.product) === null || _a === void 0 ? void 0 : _a.offer;
    const showProfessionalList = !isStudentLicense && (isMobile || hasOffer);
    const showDescription = !isMobile && (isStudentLicense || !hasOffer);
    const licenseType = isStudentLicense ? 'student' : 'professional';
    const title = t(i18n_1.Strings.userOnboarding.subsSheet.buy[licenseType].title);
    const description = t(i18n_1.Strings.userOnboarding.subsSheet.buy[licenseType].description);
    //For German + long-text languages.
    const titleRef = (0, react_1.useRef)(null);
    const defaultFontSize = isMobile ? 14 : 32;
    const [fontSize, setFontSize] = react_1.default.useState(defaultFontSize);
    react_1.default.useEffect(() => {
        if (titleRef.current) {
            const titleWidth = titleRef.current.offsetWidth;
            if (titleWidth >= 224) {
                !isMobile && setFontSize(28);
            }
            else {
                !isMobile && setFontSize(32);
            }
        }
    }, [titleRef, fontSize, isMobile]);
    return ((0, jsx_runtime_1.jsxs)(LicenseHeader, { isMobile: isMobile, "data-e2e": 'SubscriptionCardLicenseInfo_LicenseHeader', children: [(0, jsx_runtime_1.jsx)(LicenseTitle, { ref: titleRef, fontSize: fontSize, isMobile: isMobile, "data-e2e": 'SubscriptionCardLicenseInfo_LicenseTitle', children: title }), isMobile && ((0, jsx_runtime_1.jsx)(BottomText, { "data-e2e": 'SubscriptionCardLicenseInfo_BottomText', children: t(i18n_1.Strings.userOnboarding.subsSheet.buy.annual) })), (0, jsx_runtime_1.jsx)(LicenseSubtitle, { isMobile: isMobile, "data-e2e": 'SubscriptionCardLicenseInfo_LicenseSubtitle', children: t(i18n_1.Strings.userOnboarding.subsSheet.buy.access) }), showProfessionalList && ((0, jsx_runtime_1.jsxs)(List, { isMobile: isMobile, "data-e2e": 'SubscriptionCardLicenseInfo_List', children: [(0, jsx_runtime_1.jsx)(StyledListItem, { isMobile: isMobile, isGerman: isGerman, "data-e2e": 'SubscriptionCardLicenseInfo_StyledListItem', children: t(i18n_1.Strings.userOnboarding.subsSheet.buy.professional.presentation) }), (0, jsx_runtime_1.jsx)(StyledListItem, { isMobile: isMobile, isGerman: isGerman, "data-e2e": 'SubscriptionCardLicenseInfo_StyledListItem', children: t(i18n_1.Strings.userOnboarding.subsSheet.buy.professional.rights) })] })), showDescription && ((0, jsx_runtime_1.jsx)(LicenseDescription, { "data-e2e": 'SubscriptionCardLicenseInfo_LicenseDescription', children: description }))] }));
}
exports.SubscriptionCardLicenseInfo = SubscriptionCardLicenseInfo;
const LicenseHeader = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  justify-content: center;

  width: 166px;
  height: auto;
  gap: 6px;
  margin-left: 5px;

  //For tablets and larger screens.
  ${({ isMobile }) => !isMobile &&
    `
      width: 234px;
      height: 115px;
      gap: 12px;
      margin-left: 0px;
  `}
`;
const LicenseTitle = (0, styled_components_1.default)(Title_1.Title) `
  color: #17242a;
  font-size: ${({ fontSize }) => fontSize}px;
  white-space: nowrap;
  align-self: center;

  font-weight: 700;
  line-height: 24px;

  //For tablets and larger screens.
  ${({ isMobile }) => !isMobile &&
    `
      width: auto;
      height: 115px;
      gap: 12px;

      font-weight: 400;
      line-height: 40px;
  `}

  ${({ isMobile }) => isMobile &&
    `
      line-height: 12px;
  `}
`;
const LicenseSubtitle = (0, styled_components_1.default)(Subtitle_1.Subtitle) `
  color: #17242a;
  font-weight: 700;

  font-size: 13px;
  line-height: 15px;

  //For tablets and larger screens.
  ${({ isMobile }) => !isMobile &&
    `
      font-size: 12px;
      text-transform: uppercase;
  `}
`;
const LicenseDescription = (0, styled_components_1.default)(Subtitle_1.Subtitle) `
  color: #17242a;
  font-size: 14px;
  font-weight: 400;
  line-height: 17.5px;

  height: 36px;
  width: 205px;
  align-self: center;
`;
const BottomText = styled_components_1.default.p `
  min-height: 10px;
  height: auto;
  margin: 0;
  align-self: center;

  font-size: 12px;
  color: #4b4f55;
`;
const List = styled_components_1.default.ul `
  display: flex;
  flex-direction: column;

  width: auto;
  height: auto;
  margin: 0 0 0 1.8em;
  padding: 0;

  color: #4b4f55;
  font-size: 12px;
  line-height: 15px;
  text-align: left;
  align-items: left;

  ${({ isMobile }) => !isMobile && `align-items: center;`};
`;
const StyledListItem = styled_components_1.default.li `
  color: #4b4f55;

  ${({ isMobile }) => !isMobile &&
    `
    padding-left: 0em;
    
    &:nth-of-type(2) {
      margin: 0 0.5em;
    }
  `};

  ${({ isMobile, isGerman }) => !isMobile &&
    isGerman &&
    `
    &:nth-of-type(2) {
      margin: 0 3.75em;
    }
  `};
`;
